import React from "react";
import LegacyEditTransfer from "../../../AddsEdits/Student/EditTransfer.js";

export default function EditTransferDialog({
  open,
  onClose,
  transferDate,
  studentId,
  adultId,
  personType = "STUDENT",
  transferId,
  campuses = [],
  onSaved,
}) {
  const isAdult =
    String(personType || "").toUpperCase() === "ADULT" ||
    (adultId && Number(adultId) !== 0);

  const personId = isAdult ? adultId : studentId;

  const target = isAdult
    ? { personType: "ADULT", adultId: Number(adultId) }
    : { personType: "STUDENT", studentId: Number(studentId) };

  return (
    <LegacyEditTransfer
      open={open}
      onClose={onClose}
      hideTrigger
      transferDate={transferDate}
      person_id={personId}
      isAdult={isAdult}
      transfer_id={transferId}
      campuses={campuses}
      editTransfer={(payload, tid) => onSaved?.(payload, target, tid)}
    />
  );
}
